import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation DeleteIntegrationConnectorDefinition(
    $tenantId: ID!
    $zoneId: ID!
    $id: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        deleteIntgConnectorDefinition(id: $id)
      }
    }
  }
`

export const execute = graphql.createExecutor<
  graphql.schema.DeleteIntegrationConnectorDefinitionMutation,
  void,
  graphql.schema.DeleteIntegrationConnectorDefinitionMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
